var exports = {
  "PE": "Layout__I4d2xw",
  "UC": "Content__YMK67W",
  "zb": "IssueContent__7Jatit",
  "wv": "SidePanel__rd5eqD",
  "OK": "HiddenSidePanel__4pJ7G-",
  "Do": "ChildIssueSidePanel___YH79w",
  "Kt": "SidePanelLayout__vmupAq",
  "k_": "SidePanelIssueView__GXE-dl",
  "jH": "SidePanelIssuePortalRoot__ZNo3Co",
  "Vz": "SidePanelArtifactView__XDFVAN",
};

module.exports = exports;
